import React, { useState } from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { unixFormat } from '../../../../helpers/times';
import { CButton } from '../../../UI';
import { expandedStyle } from '../Episode';

import './style.scss';

export default ({episode, className, style}) => {
    const $locale = useLocaleContext();

    const [expanded, setExpanded] = useState(false);

    const additionalStyle = expanded ? expandedStyle : {};

    return (
        <div
            className={`broadcast-delay ${className}`}
            style={{
                ...style,
                ...additionalStyle,
                '--delay-blur': `${episode.delayBlur}px`,
                '--delay-opacity': episode.delayOpacity / 100,
            }}
            onMouseEnter={() => setExpanded(style.width < 120)}
            onMouseLeave={() => setExpanded(false)}
        >
            <div className="broadcast-delay-wrapper">
                <div className="broadcast-delay-header">
                    <div className="broadcast-delay-header__time">
                    <span>{unixFormat(episode.timeStart, 'HH:mm')} —</span> <span>{unixFormat(episode.timeStop, 'HH:mm')}</span>
                    </div>
                </div>
                <div className="broadcast-delay-content">
                    <div className="broadcast-delay-content__title">
                        <span>
                            {$locale.getProperty(episode, 'name')}
                        </span>
                    </div>
                </div>
                <div className="broadcast-delay-footer">
                    {/* <CButton
                        icon="like"
                        blank
                        className="broadcast-delay-like"
                    /> */}
                </div>
            </div>
        </div>
    )
};
